<template>
    <div>
        <el-dialog title="取消面试" :visible.sync="cancelVisible" width="600px" center>
            <el-form ref="cancelForm" :rules="rules" :model="cancelForm" label-width="100px">
                <el-form-item label="取消类型" prop="cancelType">
                    <el-select v-model="cancelForm.cancelType" style="width:280px" clearable placeholder="请选择取消类型">
                        <el-option v-for="(item, index) in cancelTypeList" :key="index" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="取消原因" prop="cancelReason"
                    v-if="cancelForm.cancelType == 2 || cancelForm.cancelType == 3">
                    <el-input type="textarea" v-model="cancelForm.cancelReason" placeholder clearable :rows="5">

                    </el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelVisible = false">取 消</el-button>
                <el-button type="primary" plan @click="confCancelForm('cancelForm')">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import moment from "moment";
import workercrmapi from "@/script/api/workercrmapi";
import taskApi from "@/script/api/taskApi";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";

import { validateIdNo } from "@/script/validator";

export default {
    components: {},

    filters: {

    },
    data() {
        return {
            interviewId:'',
            cancelVisible: false,
            cancelForm: {
                cancelType: '',
                cancelReason: '',
            },
            rules: {
                cancelType: [
                    { required: true, message: "请选择取消类型", trigger: "change" }
                ],
                cancelReason: [
                    { required: true, message: "请输入取消原因", trigger: "change" }
                ],
            },
            cancelTypeList: [
                {
                    value: 1,
                    label: '面试者原因'
                },
                {
                    value: 2,
                    label: '面试官原因'
                },
                {
                    value: 3,
                    label: '其他原因'
                },

            ],
        }
    },
    methods: {
        cancelInterview(row) {
            this.interviewId = row.id;
            this.cancelVisible = true;
            this.cancelForm = {
                cancelType: '',
                cancelReason: '',
            };
        },
        confCancelForm(formName) {
            //确定取消
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = this.cancelForm;
                    params.interviewId = this.interviewId;
                    taskApi.$axiosCancelInterview(params).then(res => {

                        if (res.data.errno == 0) {
                            this.$message.success('取消成功');
                            this.cancelVisible = false;
                            this.$parent.querySearch();
                        } else {
                            this.$message.warning(res.data.data);
                        }
                    });
                } else {
                    console.log("err");
                }
            });
        },


    }
};
</script>

<style scoped></style>
  